import { render } from "./quickLink.vue?vue&type=template&id=63a0436a&scoped=true"
import script from "./quickLink.vue?vue&type=script&lang=js"
export * from "./quickLink.vue?vue&type=script&lang=js"

import "./quickLink.vue?vue&type=style&index=0&id=63a0436a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a0436a"]])

export default __exports__